import React from 'react'

import { ReactComponent as Minus } from '../../../../images/main/minus_usefulInfo.svg'
import { ReactComponent as Plus } from '../../../../images/main/plus_usefulInfo.svg'
import icon_green from '../../../../images/mirea/item_green.svg'

import styles from './styles.module.scss'

const InfoProduct = () => {
  const [activeField, setActiveField] = React.useState(0)
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div>
          <p className={styles.title}>
            И ещё немного о программе
          </p>
        </div>
      </div>
      <div className={styles.right}>
        <p className={styles.title}>Темы магистерских диссертаций</p>
          <div className={styles.right_item}>
            <div className={styles.right_item_questions}>
              <p
                className={
                  activeField === 2 || activeField === 3 || activeField === 4 || activeField === 5 || activeField === 6
                    ? styles.questions_disable
                    : styles.questions
                }
                onClick={() => (activeField ? setActiveField(null) : setActiveField(1))}
              >
                Культивирование эукариотических продуцентов
              </p>
            {activeField === 1 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)} />
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(1)} />
            )}
          </div>
          {activeField === 1 && (
            <>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                исследование и разработка процессов культивирования клеток CHO в различных режимах
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                исследование влияния газовой стратегии в биореакторе, компонентов питательной среды, метаболитов на рост
                и метаболизм клеток CHO
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                исследование непрерывного процесса культивирования клеток животных в режиме глюкостат
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                влияние следовых концентраций металлов в питательных средах на рост и развитие культур клеток
                млекопитающих
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                разработка непрерывного перфузионного культивирования клеток СНО, экспрессирующих моноклональные
                антитела
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                исследование влияния газовой стратегии в биореакторе на рост и метаболизм клеток CHO
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                исследование процесса культивирования мезенхимальных стволовых клеток на микроносителях
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                исследование влияния различных факторов роста и антиоксидантов на рост и развитие культуры клеток СНО, экспрессирующей моноклональные антитела терапевтического назначения
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                NEW! оценка влияния различных компонентов питательной среды на скорость роста клеток млекопитающих и качество экспрессируемого ими белка
              </p>
            </>
          )}
        </div>
          <div className={styles.right_item}>
            <div className={styles.right_item_questions}>
              <p
                onClick={() => (activeField ? setActiveField(null) : setActiveField(2))}
                className={
                  activeField === 1 || activeField === 3 || activeField === 4 || activeField === 5 || activeField === 6
                    ? styles.questions_disable
                    : styles.questions
                }
              >
                Выделение и очистка рекомбинантных белков
              </p>
            {activeField === 2 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)} />
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(2)} />
            )}
          </div>
          {activeField === 2 && (
            <>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                оптимизация процессов хроматографической очистки терапевтических антител с использованием подхода Design
                of Experiments DoE
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' draggable='false' />
                автоматизация процесса хроматографической очистки терапевтических антител и лизосомальных ферментов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                масштабирование процесса хроматографической очистки лизосомальных ферментов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                оценка влияния потенциально критических параметров процесса хроматографической очистки на критические
                показатели качества терапевтических белков с использованием подхода DoE
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                фильтрация полупродуктов очистки терапевтических белков
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                подготовка документации для передачи полупродуктов очистки терапевтических белков на исследования в
                другие отделы компании
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                исследование устойчивости технологии выделения и очистки рекомбинантного лизосомального фермента ХХХ для
                ферментозаместительной терапии
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                подбор сорбентов и условий для аффинной очистки IgG4 антитела
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                очистка терапевтических моноклональных антител с применением мультимодальных сорбентов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                оптимизация условий ионообменной хроматографии на сорбентах CaptoTM в процессе очистки моноклонального
                анти-С5-антитела
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                оптимизация параметров очистки терапевтического белка при проведении препаративной жидкостной хроматографии
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                NEW! перевод технологии выделения и очистки рекомбинантного моноклонального антитела на альтернативные сорбенты
              </p>
            </>
          )}
        </div>

          <div className={styles.right_item}>
            <div className={styles.right_item_questions}>
              <p
                onClick={() => (activeField ? setActiveField(null) : setActiveField(3))}
                className={
                  activeField === 2 || activeField === 1 || activeField === 4 || activeField === 5 || activeField === 6
                    ? styles.questions_disable
                    : styles.questions
                }
              >
                Разработка формуляций
              </p>
            {activeField === 3 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)} />
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(3)} />
            )}
          </div>
          {activeField === 3 && (
            <>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка технологического процесса производства лекарственных препаратов на основе моноклональных
                антител в виде лиофилизатов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка состава и технологии лиофилизированных лекарственных форм на основе моноклональных антител
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                подходы к разработке состава биотехнологических лекарственных препаратов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                исследование влияния стрессовых условий на свойства и структуру белка
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка технологического процесса производства лекарственных препаратов на основе моноклональных антител в виде лиофилизатов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                NEW! изучение профиля деградации белковых молекул посредством проведения различных стресс-испытаний
              </p>
            </>
          )}
        </div>

          <div className={styles.right_item}>
            <div className={styles.right_item_questions}>
              <p
                onClick={() => (activeField ? setActiveField(null) : setActiveField(4))}
                className={
                  activeField === 2 || activeField === 3 || activeField === 1 || activeField === 5 || activeField === 6
                    ? styles.questions_disable
                    : styles.questions
                }
              >
                Фармацевтический анализ
              </p>
            {activeField === 4 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)} />
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(4)} />
            )}
          </div>
          {activeField === 4 && (
            <>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка метода скоростной седиментации для анализа распределения терапевтических молекул
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка методики картирования дисульфидных связей в терапевтическом белке при помощи
                полуспецифического протеолиза и bottom-up хромато-масс-спектрометрии
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка модуля полуколичественного анализа модификаций терапевтических белков по данным
                хромато-масс-спектрометрии bottom-up
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                оптимизация условий фрагментации с захватом электрона при хромато-масс-спектрометрическом анализе
                bottom-up для поиска и детального анализа лабильных посттрансляционных модификаций терапевтических
                белков
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                изучение биологических свойств терапевтического моноклонального антитела с применением культур клеток
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка и квалификация методики хромато-масс-спектрометрического пептидного картирования биспецифического моноклонального антитела
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                NEW! разработка и валидация методов оценки иммуногенности терапевтических белковых препаратов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                NEW! Сравнение режимов информационно-зависимого (DDA) и информационно-независимого (DIA) анализа для хромато-масс-спектрометрического пептидного картирования терапевтических белков
              </p>
            </>
          )}
        </div>

          <div className={styles.right_item}>
            <div className={styles.right_item_questions}>
              <p
                onClick={() => (activeField ? setActiveField(null) : setActiveField(5))}
                className={
                  activeField === 2 || activeField === 3 || activeField === 1 || activeField === 4 || activeField === 6
                    ? styles.questions_disable
                    : styles.questions
                }
              >
                Молекулярная диагностика
              </p>
            {activeField === 5 ? (
              <Minus className={styles.right_item_img} onClick={() => setActiveField(null)} />
            ) : (
              <Plus className={styles.right_item_img} onClick={() => setActiveField(5)} />
            )}
          </div>
          {activeField === 5 && (
            <>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка диагностического набора для определения антител к ХХХ вирусам в образцах сыворотки крови
                человека
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка и аттестация контрольных панелей при разработке диагностических наборов (конкретный пример
                набора после подписания CDA)
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка аналитического метода цифровой ПЦР для определения ХХХ аналитов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                подходы к разработке и валидации методов количественного определения аналита ХХХ в вирусологическом
                клеточном тесте
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                разработка методики обнаружения низких концентраций аналита молекулярно-биологическими методами
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                NEW! разработка методов специфической активности, подлинности и специфической безопасности генотерапевтических лекарственных средств
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                NEW! разработка метода секвенирования полиндромов и GC – богатых участков ДНК, для верификации участков ДНК, кодирующих последовательность некоторых вирусов
              </p>
              <p className={styles.answer}>
                <img src={icon_green} alt='circle' />
                NEW! определение концентрации вирусного генома с помощью методов молекулярной биологии, такие как: qPCR, ddPCR, Саузерн-блот. Апробация данных методов
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default InfoProduct
